import { ActivityNames } from './types'

export function getRanges(
  key: ActivityNames,
  difficultyLevel: number,
): {
  multiplierLen: number
  multiplicandMax: number
  multiplicandMin: number
} {
  let multiplierLen: number
  let multiplicandMax: number
  let multiplicandMin: number

  switch (key) {
    case 'LONG_MULTI_1':
      multiplicandMin = 2
      multiplicandMax = Math.random() < 0.9 ? 4 : 9

      switch (difficultyLevel) {
        case 1:
          multiplierLen = 2
          break

        case 2:
          multiplierLen = 3
          break

        default:
          throw new Error(`Invalid difficulty level: ${difficultyLevel}`)
      }
      break

    default:
      throw new Error(`Invalid key: ${key}`)
  }

  return {
    multiplierLen,
    multiplicandMax,
    multiplicandMin,
  }
}

export function getRanges2(
  key: ActivityNames,
  difficultyLevel: number,
): {
  multiplicandDigitMax: number
  multiplicandDigitMin: number
  multiplicandLen: number
  multiplierDigitMax: number
  multiplierDigitMin: number
  multiplierLen: number
} {
  let multiplicandDigitMax: number
  let multiplicandDigitMin: number
  let multiplicandLen: number
  let multiplierDigitMax: number
  let multiplierDigitMin: number
  let multiplierLen: number

  switch (difficultyLevel) {
    case 1:
    case 3:
      multiplicandDigitMax = 5
      multiplicandDigitMin = 2
      multiplierDigitMax = 5
      multiplierDigitMin = 1
      break

    case 2:
    case 4:
      multiplicandDigitMax = 9
      multiplicandDigitMin = 2
      multiplierDigitMax = 9
      multiplierDigitMin = 2
      break

    default:
      throw new Error(`Invalid difficulty level: ${difficultyLevel}`)
  }

  switch (key) {
    case 'LONG_MULTI_2':
      multiplicandLen = 1

      switch (difficultyLevel) {
        case 1:
        case 2:
          multiplierLen = 2
          break

        case 3:
        case 4:
          multiplierLen = 3
          break

        default:
          throw new Error(`Invalid difficulty level: ${difficultyLevel}`)
      }
      break

    case 'LONG_MULTI_TWO_DIGIT':
      multiplicandLen = 2

      switch (difficultyLevel) {
        case 1:
        case 2:
          multiplierLen = 2
          break

        case 3:
        case 4:
          multiplierLen = 3
          break

        default:
          throw new Error(`Invalid difficulty level: ${difficultyLevel}`)
      }
      break

    case 'LONG_MULTI_THREE_DIGIT':
      multiplicandLen = 3

      switch (difficultyLevel) {
        case 1:
        case 2:
          multiplierLen = 3
          break

        case 3:
        case 4:
          multiplierLen = 4
          break

        default:
          throw new Error(`Invalid difficulty level: ${difficultyLevel}`)
      }
      break

    case 'LONG_MULTI_DECIMAL':
      multiplicandLen = 2
      multiplierLen = 2
      break

    case 'LONG_MULTI_DECIMAL_TWO_DIGITS':
      multiplicandLen = 3
      multiplierLen = 2
      break

    case 'LONG_MULTI_DECIMAL_THREE_DIGITS':
      multiplicandLen = 3
      multiplierLen = 3
      break

    case 'LONG_MULTI_DECIMAL_THREE_DIGITS2':
      multiplicandLen = 4
      multiplierLen = 3
      break

    default:
      throw new Error(`Invalid key: ${key}`)
  }

  return {
    multiplicandDigitMax,
    multiplicandDigitMin,
    multiplicandLen,
    multiplierDigitMax,
    multiplierDigitMin,
    multiplierLen,
  }
}
